<template>
  <div id="app" v-cloak>
    <Heard v-show="isShow" />
    <div class="hh">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view
        :key="Math.random() * 100"
        v-if="!$route.meta.keepAlive"
      ></router-view>
    </div>

    <Footer v-show="isShow" />
    <!-- <Side /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Heard from "@/components/Heard.vue";
import Footer from "@/components/Footer.vue";
// import Side  from "@/components/Side.vue"
export default {
  name: "Home",

  data() {
    return {
      isalive: false,
      isShow: true,
    };
  },
  watch: {
    $route(next) {
      console.log("app.vue", next);

      if (next.path == "/alipay") {
        this.isShow = false;
        console.log(this.isShow);
      } else {
        this.isShow = true;
      }
    },
  },
  created() {
    //  var ua = window.navigator.userAgent.toLowerCase();

    // if (navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    // ) {
    //   location.href = "http://m.shisw.vip";
    // }

    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    console.log("手机还是电脑：", flag ? 1 : 0);
    //手机
    if (flag) {
      if (window.location.origin == "http://shisw.net") {
        window.location.href =
          "http://m.shisw.net" +
          window.location.pathname +
          window.location.search;
      }
      if (window.location.origin == "http://www.shisw.net") {
        window.location.href =
          "http://m.shisw.net" +
          window.location.pathname +
          window.location.search;
      }
      if (window.location.origin == "http://shisw.cc") {
        window.location.href =
          "http://m.shisw.net" +
          window.location.pathname +
          window.location.search;
      }
      if (window.location.origin == "http://www.shisw.cc") {
        window.location.href =
          "http://m.shisw.net" +
          window.location.pathname +
          window.location.search;
      }
    }
    if (!flag) {
      if (window.location.origin == "http://m.shisw.net") {
        window.location.href =
          "http://shisw.net" +
          window.location.pathname +
          window.location.search;
      }
    }
  },

  components: {
    Heard,
    Footer,
    // Side
  },
  methods: {},
};
</script>
<style lang="scss">
@import "../css/base.css";
@import "../css/common.css";
@import "../css/swiper.min.css";
@import "../css/iconfont/iconfont.css";
body {
  margin: 0 0;
}
@media (min-width: 1440px) {
  body {
    overflow-x: hidden;
  }
}
.el-message--success {
  top: 40% !important;
  left: 50%;
  padding: 20px 10px;
  background-color: #888691;
  color: #fff;
  font-size: 16px;
  border-color: #888691;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-message__content {
    color: #fff;
    font-size: 16px;
    letter-spacing: 3px;
  }
}
@media (max-width: 768px) {
  .el-message-box {
    width: auto;
  }
}
.sps {
  top: 35% !important;
  left: 50%;
  padding: 20px 10px;
  color: #fff;
}
.el-message--warning {
  background-color: #888691;
  color: #fff;
  border-color: #888691;

  .el-message__content {
    color: #fff;
    font-size: 16px;
    letter-spacing: 3px;
    z-index: 333444444444;
  }
}
.el-message--error {
  background-color: #888691;
  color: #fff;
  border-color: #888691;
  top: 35% !important;
  left: 50%;
  padding: 20px 10px;
  z-index: 3000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-message__content {
    z-index: 3000444;
    color: #fff;
    font-size: 16px;
    letter-spacing: 3px;
  }
}
.hh,.bg-round{
  min-height: calc(
    100vh - 212px
  ); //减去顶部菜单的距离，实现任意屏幕的第一屏仅显示菜单和图片效果
}
</style>
